import axios from './index';

export const getLogsRequest = (values) =>
  axios.get(`/v1/vendors/get/self/activity-logs/${values?.from || '-'}/${values?.to || '-'}`);
